import * as angular from "angular";
import * as _ from "lodash";
import * as $ from "jquery";
import {IQService, IWindowService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";


export class MapFactoryService {
  constructor(private $q: IQService, private uiGmapGoogleMapApi, private splitService: SplitService, private $window: IWindowService) {
  }

  getBrowserLocation() {
    const deferred = this.$q.defer();

    if (!this.$window.navigator.geolocation) {
      deferred.reject();
    } else {
      this.$window.navigator.geolocation.getCurrentPosition(
        (position) => {
          deferred.resolve(position);
        },
        (err) => {
          deferred.reject();
        });
    }

    return deferred.promise;
  }

  createMap(element) {
    const deferred = this.$q.defer();

    this.uiGmapGoogleMapApi.then(
      (maps) => {

        const mapOptions = {
            center: this.splitService.getSiteAddress().location,
            zoom: 15,
            options: {
              mapTypeControl: false,
              mapTypeId: maps.MapTypeId.ROADMAP,
              panControl: false,
              scrollwheel: false
            }
          },
          map = new maps.Map(element, mapOptions);

        deferred.resolve(map);
      }
    );

    return deferred.promise;
  }

  centerToCircles(map, circles) {
    const bounds = new google.maps.LatLngBounds();

    $.each(circles, (index, circle) => {
      bounds.union(circle.getBounds());
    });

    map.fitBounds(bounds);
  }

  centerMap(map, markersArrays) {

    if (!_.isEmpty(markersArrays)) {
      const bounds = new google.maps.LatLngBounds();
      markersArrays.forEach(function (markers) {
        markers.forEach(function (marker) {
          bounds.extend(marker.position);
        });
      });

      map.fitBounds(bounds);
    }
  }

  centerMarkers(map, markers) {

    if (!_.isEmpty(markers)) {
      const bounds = new google.maps.LatLngBounds();
      markers.forEach(function (marker) {
        bounds.extend(marker.position);
      });

      map.fitBounds(bounds);
    }
  }

}

angular
  .module('bringoz.admin.map')
  .service('mapFactoryService', MapFactoryService);
